<div class="row mt-5">
    <div class="col-12" style="padding-right: 0 !important; margin-right: 0 !important">
        <div class="mt-3">
            <!-- market value area start && countdownValue==0-->
            <div *ngIf="!loadingFiles " class="table-responsive" style="overflow-x:hidden">
                <table *ngIf="!openDeduction" class="table table-hover align-middle bg-white">
                    <thead>
                        <tr>
                            <th colspan="3">Deductions</th>
                        </tr>
                    </thead>
                    <tbody class="m-3">
                        <ng-container *ngIf="queryData.length>0">
                            <ng-container>
                                <tr class="m-3" *ngFor="let item of queryData">
                                    <td colspan="2">{{item.companyName}}
                                    </td>
                                    <td style="align-self: center;">
                                        <button class=" btn btn-sm btn-primary px-3 mr-3" type="button"
                                            (click)="viewDeduction(item)" title="View File">
                                            View
                                        </button>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="queryData.length<1">
                            <tr>
                                <td colspan="3" class="text-center">No Data
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
                <div *ngIf="openDeduction" class="table-responsive">
                    <div>
                        <button (click)="openDeduction=false" class=" btn badge badge-primary my-3"
                            type="button">Back</button>
                        <div class="card">
                            <div class="card-body" style="overflow-x: auto">
                                <h5>Deductions Each Pay</h5>
                                <table class="table table-bordered tablecenter table-hover align-middle mb-0 bg-white">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Amount Each Pay </th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Amount Owed</th>
                                            <th>Total Paid</th>
                                            <th>Balance</th>
                                            <th colspan="2"></th>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="unlimitTable">
                                        <tr *ngFor="let item of unlimitedData">
                                            <th>{{item.name?item.name:'-'}}</th>
                                            <td>{{item.amount?(item.amount | number:'1.2-2'):'-'}}</td>
                                            <td>{{(item.date_from!='-' && item.date_from!=null )?(item.date_from |
                                                date: 'yyyy-MM-dd'):'-'}}</td>
                                            <td>
                                                {{ (item.date_to != '-' && item.date_to != 'PAID'&&
                                                item.date_to!=null ) ? (item.date_to | date: 'yyyy-MM-dd') :'-' }}
                                            </td>
                                            <td>{{item.amount_owed?(item.amount_owed |number:'1.2-2'):'-'}}</td>
                                            <td>{{item.amount_taken?(item.amount_taken|number:'1.2-2'):'-'}}</td>
                                            <td>{{(item.balance||item.balance==0)?(item.balance |number:'1.2-2'):'-'}}
                                            </td>
                                            <td *ngIf="item.isAstute===false">
                                                <app-status-icons
                                                    [statusValue]="(item.status=='Complete'|| item.status =='manual')?'true':'false'"></app-status-icons>
                                            </td>
                                            <td *ngIf="item.isAstute===false">
                                                <span *ngIf="item.fileId" style="display: flex; align-items: center;">
                                                    <button class="btn btn-sm btn-primary mr-1" title="Download"
                                                        (click)="onClickDownload(item)">
                                                        <i class="fa fa-download" style="font-size: 12px"></i>
                                                    </button>
                                                    <button title="View" [id]="'item_' + item.id"
                                                        class="btn btn-sm btn-info" (click)="onClickView(item)">
                                                        <i class="fa fa-file-text-o" style="font-size: 12px"></i>
                                                    </button>
                                                </span>
                                                <span *ngIf="!item.fileId || item.isSigned===false">
                                                    <button disabled title="Check your email to add sign."
                                                        class="btn btn-sm px-3 btn-light"
                                                        *ngIf="item.isSigned===false">Pending</button>
                                                    <button *ngIf="item.isSigned!==false && item.isSigned!==true"
                                                        type="button" class="btn btn-sm btn-secondary px-3 "
                                                        data-toggle="modal" data-target="#AuthorityModal"
                                                        (click)="createDeductionSlip(item)" title="Sign File">
                                                        Sign
                                                    </button>
                                                </span>
                                            </td>
                                            <td *ngIf="item.isAstute===true" colspan="2"></td>
                                        </tr>
                                    </tbody>
                                    <tbody *ngIf="!unlimitTable">
                                        <tr>
                                            <td colspan="8" class="text-center"> No data. </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div class="card">
                            <div class="card-body" style="overflow-x: auto">
                                <h5>Fixed Deductions</h5>
                                <table class="table table-bordered tablecenter table-hover align-middle mb-0 bg-white">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Amount Each Pay </th>
                                            <th>Start Date</th>
                                            <th>Estimated End Date</th>
                                            <th>Total Amount</th>
                                            <th>Total Paid</th>
                                            <th>Balance</th>
                                            <th colspan="2"></th>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="fixTable">
                                        <tr *ngFor="let item of fixedData">
                                            <th>{{item.name?item.name:'-'}}</th>
                                            <td>{{item.amount?(item.amount | number:'1.2-2'):'-'}}</td>
                                            <td>{{(item.date_from!='-' && item.date_from!=null )?(item.date_from |
                                                date: 'yyyy-MM-dd'):'-'}}</td>
                                            <td>
                                                {{ (item.date_to != '-' && item.date_to != 'PAID' && item.date_to !=
                                                null)? (item.date_to | date: 'yyyy-MM-dd') :item.date_to ==
                                                'PAID'?'PAID': '-' }}
                                            </td>
                                            <td>{{item.limit_fixed?(item.limit_fixed | number:'1.2-2'):'-'}}</td>
                                            <td>{{item.amount_taken?(item.amount_taken |number:'1.2-2'):'-'}}</td>
                                            <td>{{(item.balance||item.balance==0)?(item.balance |number:'1.2-2'):'-'}}
                                            </td>
                                            <td *ngIf="item.isAstute===false">
                                                <app-status-icons [statusValue]="(item.status=='Complete'|| item.status =='manual')?'true':'false'"></app-status-icons>
                                            </td>
                                            <td *ngIf="item.isAstute===false">
                                                <span *ngIf="item.fileId " style="display: flex; align-items: center;">
                                                    <button class="btn btn-sm btn-primary mr-1" title="Download"
                                                        (click)="onClickDownload(item)">
                                                        <i class="fa fa-download" style="font-size: 12px"></i>
                                                    </button>
                                                    <button title="View" [id]="'item_' + item.id"
                                                        class="btn btn-sm btn-info" (click)="onClickView(item)">
                                                        <i class="fa fa-file-text-o" style="font-size: 12px"></i>
                                                    </button>
                                                </span>
                                                <span *ngIf="!item.fileId || item.isSigned===false ">
                                                    <button disabled title="Check your email to add sign."
                                                        class="btn btn-sm px-3 btn-light"
                                                        *ngIf="item.isSigned===false">Pending</button>
                                                    <button *ngIf="item.isSigned!==false && item.isSigned!==true"
                                                        type="button" class="btn btn-sm btn-secondary "
                                                        data-toggle="modal" data-target="#AuthorityModal"
                                                        (click)="createDeductionSlip(item)" title="Sign File">
                                                        Sign
                                                    </button>
                                                </span>
                                            </td>
                                            <td *ngIf="item.isAstute===true" colspan="2"></td>
                                        </tr>
                                    </tbody>
                                    <tbody *ngIf="!fixTable">
                                        <tr>
                                            <td colspan="8" class="text-center"> No data. </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- market value area end -->
                </div>
            </div>
            <div *ngIf="loadingFiles">
                <li class="t_loader">
                    <div class="card__desc load" id="long"></div>
                </li>
                <li class="t_loader">
                    <div class="card__desc load"></div>
                </li>
                <li class="t_loader">
                    <div class="card__desc load" id="long"></div>
                </li>
                <li class="t_loader">
                    <div class="card__desc load"></div>
                </li>
                <li class="t_loader">
                    <div class="card__desc load" id="long"></div>
                </li>
                <li class="t_loader">
                    <div class="card__desc load"></div>
                </li>
            </div>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="AuthorityModal" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog"
    aria-labelledby="AuthorityModalTitle" aria-hidden="true" [style.z-index]="showDocuSignInModal ? '9999' : '1050'">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="AuthorityModalTitle">Authority To Deduct</h5>
                <button *ngIf="!showDocuSignInModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- DocuSign iframe content -->
                <div *ngIf="showDocuSignInModal" class="docuSign-container">

                    <div *ngIf="docuSignLoading" class="text-center mt-3 my-3">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading DocuSign...</span>
                        </div>
                    </div>
                    <iframe
                        *ngIf="!docuSignLoading"
                        [src]="sanitizedDocuSignUrl"
                        width="100%"
                        height="600px"
                        frameborder="0"
                        style="border: 2px solid black;"
                        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation allow-modals"
                        allow="camera; microphone; geolocation; autoplay; encrypted-media"
                        (load)="onDocuSignIframeLoad()"
                        (error)="onDocuSignIframeError()"
                        class="docuSign-iframe">
                    </iframe>
                </div>

                <!-- Original modal content -->
                <div *ngIf="!showDocuSignInModal && !loading && !successMessage" class="card table-responsive">
                    <ng-container *ngIf="brandName.includes('Health'); else legacyView">
                        <app-letterhead-a4 [brandType]="'healthpluspeople'">
                            <div class="mx-4">
                                <h3> <strong>AUTHORITY FOR PAYROLL DEDUCTIONS</strong> </h3>
                                <h6>I <strong> {{name}} </strong>authorize {{brandName}} Pty Ltd to make
                                    deductions to my pay, as specified in the table below.</h6>
                                <div class="table-responsive">
                                    <table class="table table-bordered table-hover ">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col">Description</th>
                                                <th scope="col">Amount Each Pay</th>
                                                <th scope="col">Total Amount</th>
                                                <th scope="col">Commencing</th>
                                                <th scope="col">Notes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of dataATD">
                                                <td scope="row">{{item.name}}</td>
                                                <td>${{item.amount | number:'1.2-2'}}</td>
                                                <td>${{item.total_paid?(item.total_paid | number:'1.2-2'):'-'}}</td>
                                                <td>{{item.date_from | date:'MMM d, y'}}</td>
                                                <td>{{item.note?item.note:"-"}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br><br>
                                <br><br>
                                <br><br>
                                <div>
                                    <p><b class="mr-4">Signature:</b></p>
                                    <p><b class="mr-4">Date:</b> {{currentDate| date:'medium'}} </p>
                                </div>
                            </div>
                        </app-letterhead-a4>
                    </ng-container>

                    <ng-template #legacyView>
                        <app-letterhead-a4 [brandType]="'agrilabour'" [useLegacyView]="true">
                            <!-- Insert the current deductions markup here so it prints within the letterhead -->
                            <div class="mx-4">
                                <h3> <strong>AUTHORITY FOR PAYROLL DEDUCTIONS</strong> </h3>
                                <h6>I <strong> {{name}} </strong>authorize {{brandName}} Pty Ltd to make
                                    deductions to my pay, as specified in the table below.</h6>
                                <div class="table-responsive">
                                    <table class="table table-bordered table-hover ">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col">Description</th>
                                                <th scope="col">Amount Each Pay</th>
                                                <th scope="col">Total Amount</th>
                                                <th scope="col">Commencing</th>
                                                <th scope="col">Notes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of dataATD">
                                                <td scope="row">{{item.name}}</td>
                                                <td>${{item.amount | number:'1.2-2'}}</td>
                                                <td>${{item.total_paid?(item.total_paid | number:'1.2-2'):'-'}}</td>
                                                <td>{{item.date_from | date:'MMM d, y'}}</td>
                                                <td>{{item.note?item.note:"-"}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br><br>
                                <br><br>
                                <br><br>
                                <div>
                                    <p><b class="mr-4">Signature:</b></p>
                                    <p><b class="mr-4">Date:</b> {{currentDate| date:'medium'}} </p>
                                </div>
                                <div class="mt-5">
                                    <h2 style="color: #ECB41F;">LABOUR HIRE</h2>
                                    <h2 style="color: #624891;">PERMANENT RECRUITMENT</h2>
                                </div>
                            </div>
                        </app-letterhead-a4>
                    </ng-template>
                </div>
                <div *ngIf="loading && !showDocuSignInModal" class="text-center mt-3 my-3">
                    <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <p>Please wait, processing your request...</p>
                </div>
                <div *ngIf="successMessage && !showDocuSignInModal" class="text-center mt-3 text-success">
                    <p>Submission successful! <br> {{ successMessage }}</p>
                    <button type="button" class="btn btn-primary" (click)="openDocuSign();"><a
                            style="color: white;">Open DocuSign</a></button>
                </div>
            </div>
            <div class="modal-footer">
                <button *ngIf="!showDocuSignInModal" type="button" class="btn btn-secondary" data-dismiss="modal"
                    (click)="loading=false; successMessage?openDeduction=false:''">Close</button>
                <button *ngIf="!showDocuSignInModal && !loading && !successMessage" type="button" class="btn btn-primary"
                    (click)="submitATD()">Add Sign</button>
            </div>
        </div>
    </div>
</div>

<!-- Custom Exit Confirmation Modal -->
<div *ngIf="showExitConfirmation" class="modal fade show" style="display: block; background-color: rgba(0,0,0,0.5);"
     tabindex="-1" role="dialog" aria-labelledby="exitConfirmationTitle" aria-hidden="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title" id="exitConfirmationTitle">Leave DocuSign?</h5>
            </div>
            <div class="modal-body text-center py-4">
                <p class="mb-0">Your signing progress may be lost if you leave now.</p>
            </div>
            <div class="modal-footer border-0 pt-0 justify-content-center">
                <button type="button" class="btn btn-secondary me-2" (click)="cancelExit()">
                    Cancel
                </button>
                <button type="button" class="btn btn-danger" (click)="confirmExit()">
                    Leave
                </button>
            </div>
        </div>
    </div>
</div>